<template>
    <div>
        <p>            
            <h3>Welcome <span class="span">TestPage</span></h3>
        </p>       
    </div>
</template>
<script>
    export default {
        data() {

        },        
    }
</script>

<style>
    .span {
        color: blue;
        /*background-color: red;*/
        font-size: 3rem;
    }
</style>

